import { createApp } from 'vue'
import App from './App.vue'
import store from './store'
import VueDeviceDetect from '@basitcodeenv/vue3-device-detect'
import '@fortawesome/fontawesome-free/css/all.css'
import '@fortawesome/fontawesome-free/js/all.js'
import i18n from './i18n'

let app = createApp(App)
app.use(i18n)
app.use(store)
app.use(VueDeviceDetect)
app.mount('#app')
